import React from "react"
import PropTypes from "prop-types"
import { StyledLink, StyledA, StyledButton, Number } from "./styles"

const Button = ({ children, number, ...rest }) => {
  if (!!number)
    return (
      <StyledButton number={number} {...rest}>
        {children}
        <Number {...rest}>{number}</Number>
      </StyledButton>
    )
  else if (rest.to) return <StyledLink {...rest}>{children}</StyledLink>
  else if (rest.href || rest.tableCellLink)
    return (
      <StyledA {...rest} rel="noopender noreferrer">
        {children}
      </StyledA>
    )
  else return <StyledButton {...rest}>{children}</StyledButton>
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.string,
  variant: PropTypes.oneOf(["default", "primary", "secondary", "white", "success", "danger", "special"]),
  size: PropTypes.oneOf(["small", "default", "medium", "large"]),
  outlined: PropTypes.bool,
  fullwidth: PropTypes.bool,
  onClick: PropTypes.func,
  number: PropTypes.string,
  iconOnly: PropTypes.bool,
  flexGrow: PropTypes.bool
}

Button.defaultProps = {
  to: null,
  href: null,
  variant: "default",
  size: "default",
  outlined: false,
  fullwidth: false,
  onClick: undefined,
  number: "",
  iconOnly: false,
  flexGrow: false
}

export default Button
